import { replaceNode } from '../utils'

export default class RemoteForm extends HTMLElement {
  connectedCallback() {
    this.form.onsubmit = this.submit.bind(this)
  }

  disconnectedCallback() {
    if (this.form) this.form.onsubmit = null
  }

  async submit(event) {
    event.preventDefault()
    this.toggleButtonState()
    const url = this.form.getAttribute('action')
    const response = await fetch(url, {
      method: this.form.getAttribute('method') || 'post',
      body: this.formData,
      credentials: 'same-origin',
      headers: new Headers({
        'X-Requested-With': 'XMLHttpRequest'
      })
    })

    const content = await response.text()
    this.transclude(content)
  }

  transclude(content) {
    const dom = document.createElement('div')
    dom.innerHTML = content
    replaceNode(this, ...dom.children)
    this.toggleButtonState()
  }

  toggleButtonState() {
    const waitLabel = this.button.getAttribute('data-wait-label') || '…'

    if (this.button.hasAttribute('disabled')) {
      this.button.removeAttribute('disabled')
    } else {
      this.button.setAttribute('disabled', 'disabled')
      this.button.innerHTML = waitLabel
      this.button.setAttribute('data-label', waitLabel)
    }
  }

  get form() {
    return this.querySelector('form')
  }

  get formData() {
    return new FormData(this.form)
  }

  get button() {
    return (
      this.querySelector('button[type=submit]') ||
      this.querySelector('input[type=submit]')
    )
  }
}
